var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdicule = function SvgEdicule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 2.643 32.357 15H35v3.333h-1.667v15h3.334v3.334H3.333v-3.334h3.334v-15H5V15h2.643zm-10 15.69v15h8.333v-15zm11.667 0v15H30v-15zM27.643 15 20 7.357 12.357 15z"
  })));
};
export default SvgEdicule;